import {
	SET_ERROR,
	CORE_AUTH_VERIFY_SUCCESS,
	CORE_AUTH_VERIFY_FAILURE,

	CORE_GET_RM_TAG_REQUEST,
	CORE_GET_RM_TAG_SUCCESS,
	CORE_GET_RM_TAG_FAILURE,

	CORE_CREATE_RM_TAG_REQUEST,
	CORE_CREATE_RM_TAG_SUCCESS,
	CORE_CREATE_RM_TAG_FAILURE,

	CORE_GET_PD_TAG_REQUEST,
	CORE_GET_PD_TAG_SUCCESS,
	CORE_GET_PD_TAG_FAILURE,

	CORE_CREATE_PD_TAG_REQUEST,
	CORE_CREATE_PD_TAG_SUCCESS,
	CORE_CREATE_PD_TAG_FAILURE,



} from '../types'


const initialStateCallAPI = {
	isLoading: false,

	hasError: false,
	errorMessage: '',
	errorCode: '',
	statusText: ''
}
	, initialStateArray = []


export default {
	errorList: (state = initialStateArray, action) => {
		switch (action.type) {
			case SET_ERROR:
				let newError = []
				if (action && Array.isArray(action.error)) {
					newError = action.error
				}
				return newError

			case CORE_AUTH_VERIFY_SUCCESS:
				if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
					const { errors, result } = action.payload
					const { url } = action
					let newError = []
					if (!result) {
						if (Array.isArray(errors)) {
							errors.map(e => {
								const { path, code, message } = e
								return newError.push({ code, message, isShow: true, path, url, isFromAction: true })
							})
						}
						else newError.push({ code: "unknow", message: "Some thing went wrong", isShow: true, path: "", url, isFromAction: true })
					}

					return newError
				}
				return state

			case CORE_AUTH_VERIFY_FAILURE:
				if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
					const { code, message, statusText, statusCode } = action.payload
					const { url } = action
					let newError = []

					newError.push({
						code: code ? code : "404",
						message,
						isShow: false,
						statusText,
						statusCode,
						url
					})

					return newError
				}
				return state
			default:
				return state
		}
	},
	isLoading: (state = false, action) => {
		switch (action.type) {
			// case CORE_GET_TRANSFER_BY_ID_REQUEST:
			case CORE_GET_RM_TAG_REQUEST:
			case CORE_CREATE_RM_TAG_REQUEST:
			case CORE_GET_PD_TAG_REQUEST:
			case CORE_CREATE_PD_TAG_REQUEST:
				return true
			// case CORE_GET_TRANSFER_BY_ID_SUCCESS:
			case CORE_GET_RM_TAG_SUCCESS:
			case CORE_CREATE_RM_TAG_SUCCESS:
			case CORE_GET_PD_TAG_SUCCESS:
			case CORE_CREATE_PD_TAG_SUCCESS:
				return false
			// case CORE_GET_TRANSFER_BY_ID_FAILURE:
			case CORE_GET_RM_TAG_FAILURE:
			case CORE_CREATE_RM_TAG_FAILURE:
			case CORE_GET_PD_TAG_FAILURE:
			case CORE_CREATE_PD_TAG_FAILURE:
				return false
			default:
				return state
		}

	},
	reducerCallAPI: (state = initialStateCallAPI, action) => {
		switch (action.type) {

			default:
				return state
		}
	},

}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerCallAPI.js